import { createSlice } from "@reduxjs/toolkit";

let initialFormComponents = [
  {
    stepName: "Request",
    stepTabLabel: "Request",
    stepTabVisible: true,
    stepTabEnabled: true,
    stepCompleted: false,
  },
  {
    stepName: "AddToCart",
    stepTabLabel: "Add to Cart",
    stepTabVisible: true,
    stepTabEnabled: false,
    stepCompleted: false,
  },
];

const configureStepComponents = (
  Id,
  cardTypeValue,
  formStepComponents,
  currentStepName = ""
) => {
  if (currentStepName) {
    let markedCompleted = false;
    for (const i in formStepComponents) {
      let step = formStepComponents[i];
      if (
        formStepComponents[i].stepName !== currentStepName &&
        !markedCompleted
      ) {
        formStepComponents[i].stepCompleted = true;
        formStepComponents[i].stepTabEnabled = true;
      } else {
        markedCompleted = true;
      }
    }
  }

  if (Id) {
    // override defaults if existing cart item
    formStepComponents[1].stepTabLabel = "Update Cart";
  }

  return formStepComponents;
};

const getNextConfiguratorStep = (currentStep, cardTypeValue) => {
  let nextStep = "";
  if (currentStep === "Request") {
    nextStep = "AddToCart";
  }
  return nextStep;
};

const setNextStepProgress = (state) => {
  let newFormStep = getNextConfiguratorStep(
    state.FormStep,
    state.ConfiguratorRequest.DonorRequest.CardTypeValue
  );
  state.FormStep = newFormStep;
  let formStepComponents = initialFormComponents.map((item) => {
    return { ...item };
  });
  state.FormStepComponents = configureStepComponents(
    state.ConfiguratorRequest.DonorRequest.Id,
    state.ConfiguratorRequest.DonorRequest.CardTypeValue,
    formStepComponents,
    newFormStep
  );
};

const configuratorSlice = createSlice({
  name: "configurator",
  initialState: {
    Loaded: false,
    AddingToCart: false,
    FormStep: "Request",
    ConfiguratorRequest: {
      DonorRequest: {},
    },
    FormStepComponents: initialFormComponents,
  },
  reducers: {
    setInitialState: (state, action) => {
      let pageDefaults = action.payload.pageDefaults;
      let initialRequest = action.payload.request;

      // set defaults based on page/widget properties or cart data (if available)
      if (initialRequest.DonorRequest.Id) {
      } else {
        initialRequest.DonorRequest.CardTypeValue = "nocard";
      }

      if (initialRequest.DonorRequest.Id) {
        // override defaults if existing cart item
        state.FormStepComponents[1].stepTabLabel = "Update Cart";
      }

      // configure steps and form components based on defaults
      let formStepComponents = initialFormComponents.map((item) => {
        return { ...item };
      });
      state.FormStepComponents = configureStepComponents(
        initialRequest.DonorRequest.Id,
        initialRequest.DonorRequest.CardTypeValue,
        formStepComponents
      );

      state.Loaded = true;
      state.FormStep = "Request";
      state.ConfiguratorRequest = initialRequest;
    },
    setFormStep: (state, action) => {
      let formStepComponents = initialFormComponents.map((item) => {
        return { ...item };
      });
      state.FormStepComponents = configureStepComponents(
        state.ConfiguratorRequest.DonorRequest.Id,
        state.ConfiguratorRequest.DonorRequest.CardTypeValue,
        formStepComponents,
        action.payload
      );
      state.FormStep = action.payload;
    },
    setRequest(state, action) {
      const submittedValues = action.payload;

      // update configurator state based on valid submitted values
      // request
      state.ConfiguratorRequest.DonorRequest.Intention =
        submittedValues.intention;

      if(submittedValues.amount === 'other') {
        state.ConfiguratorRequest.DonorRequest.OfferingAmount =
        submittedValues.customAmount;
      } else {
        state.ConfiguratorRequest.DonorRequest.OfferingAmount =
        submittedValues.amount;
      }

      state.AddingToCart = true;
    },
    setOfferingAmount(state, action) {
      state.ConfiguratorRequest.DonorRequest.OfferingAmount = action.payload;
    },
    setApprove(state, action) {
      // add/update to cart, get cart item id, update mini cart count
      state.AddingToCart = false;
      state.ConfiguratorRequest.CartItemId = action.payload;
      state.ConfiguratorRequest.DonorRequest.Id = action.payload;
      setNextStepProgress(state);
    },
  },
});

export const configuratorActions = configuratorSlice.actions;

export default configuratorSlice;
